var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasketball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_16129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99986 17.64C13.7716 17.64 17.6399 13.7717 17.6399 9C17.6399 4.22826 13.7716 0.360001 8.99986 0.360001C4.22812 0.360001 0.359863 4.22826 0.359863 9C0.359863 13.7717 4.22812 17.64 8.99986 17.64Z",
    fill: "#F15827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5879 9.72C11.8799 9.54 9.71986 11.988 9.71986 15.012V15.48C9.79186 16.236 9.68386 16.992 9.46786 17.64C9.64786 17.64 9.86386 17.604 10.0439 17.568C10.2239 16.92 10.3319 16.2 10.2599 15.444C10.0439 12.42 12.0959 10.08 15.5519 10.26C16.2719 10.296 16.9199 10.224 17.5679 10.044C17.6039 9.864 17.6039 9.648 17.6399 9.468C17.0279 9.684 16.3439 9.792 15.5879 9.72ZM7.95586 0.432001C7.73986 1.08 7.66786 1.8 7.73986 2.556C7.95586 5.58 5.90386 7.92 2.41186 7.74C1.69186 7.704 1.00786 7.776 0.395863 7.956C0.359863 8.136 0.359863 8.352 0.359863 8.532C0.899863 8.352 1.43986 8.28 2.05186 8.28H2.37586C6.22786 8.496 8.49586 5.832 8.24386 2.52C8.17186 1.764 8.27986 1.008 8.49586 0.360001C8.35186 0.396001 8.13586 0.396001 7.95586 0.432001Z",
    fill: "#071123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70402 9.36C5.65202 7.308 4.14002 4.896 3.38402 2.412L2.91602 2.88C3.70802 5.292 5.18402 7.704 7.30802 9.792C9.79202 12.312 12.78 13.932 15.624 14.58L16.056 14.04C13.176 13.464 10.224 11.88 7.70402 9.36Z",
    fill: "#071123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.63992 7.704C10.6919 5.652 13.1039 4.14 15.5879 3.384L15.1199 2.916C12.7079 3.708 10.2959 5.184 8.20792 7.308C5.68792 9.792 4.06792 12.78 3.41992 15.624L3.95992 16.056C4.53592 13.176 6.11992 10.224 8.63992 7.704Z",
    fill: "#071123"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M17.6399 9C17.6399 13.788 13.7519 17.64 8.99993 17.64C6.26393 17.64 3.77993 16.344 2.23193 14.364C3.70793 15.516 5.54393 16.2 7.55993 16.2C12.3479 16.2 16.1999 12.348 16.1999 7.56C16.1999 5.544 15.5159 3.672 14.3279 2.232C16.3439 3.816 17.6399 6.264 17.6399 9Z",
    fill: "#071123"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M5.57986 14.688C4.28386 14.688 3.05986 14.436 1.97986 14.004C0.899863 12.492 0.359863 10.764 0.359863 9C0.359863 1.98 8.24386 -1.98 13.8599 1.872C16.8839 7.668 12.5279 14.688 5.57986 14.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M3.45586 12.6C2.59186 12.6 1.76386 12.492 1.00786 12.276C0.575863 11.268 0.359863 10.152 0.359863 9C0.359863 2.808 6.65986 -1.332 12.3119 1.008C12.5999 1.872 9.79186 12.6 3.45586 12.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M8.01961 8.20909C9.80506 6.42359 10.3065 4.03021 9.13958 2.86335C7.97267 1.69648 5.57932 2.19799 3.79387 3.9835C2.00842 5.76901 1.507 8.16238 2.67391 9.32924C3.84081 10.4961 6.23417 9.9946 8.01961 8.20909Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_16129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketball);
export default __webpack_public_path__ + "static/media/basketball.61e9051765e3c252d0283a601e96b20c.svg";
export { ForwardRef as ReactComponent };